(function ($) {
  $(document).ready(function ($) {
    // initial Klaviyo variable setup
    //var _learnq = _learnq || [];

    /*****************************************************************
      Klaviyo form integration
    *****************************************************************/
    var $form = $('#preview-klaviyo-form');
    var $formInner = $form.find('.form-inner');

    function KlaviyoSignup(listID, email, source) {
      var subscribed = false;
      $.ajax({
        type: 'POST',
        url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
        data: {
          g: listID,
          $fields: '$source, $consent, $email, Accepts Marketing',
          $email: email,
          $consent: ['email'],
          //pass in additional fields
          AcceptsMarketing: true,
          $source: source,
        },
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
          'cache-control': 'no-cache',
        },
        error: function (err) {
          console.log('Could not connect to Klaviyo.');
          console.log(err);

          // trigger Klaviyo's identify call just to see if it starts tracking events sitewide
          //_learnq.push(['identify', { $email: email }]);
          //klaviyo.push(['identify', { $email: email }]);
        },
        success: function (res) {
          console.log('success');
          console.log(res);
          subscribed = true;

          // trigger Klaviyo's identify call just to see if it starts tracking events sitewide
          //_learnq.push(['identify', { $email: email }]);
          //klaviyo.push(['identify', { $email: email }]);

          if (res.data.is_subscribed == false) {
            console.log('success');
            var message =
              "<p class='large'>Thanks for signing up! Keep an eye on your inbox and we'll send you the latest on our launch.</p>";

            if ($formInner.length) {
              $formInner.remove();
            }
            $form.append(message);
          }

          if (res.data.is_subscribed == true) {
            console.log('That email is already subscribed to our list');
            var message =
              "<p class='large'>That email is already subscribed to our list!</p>";

            if ($formInner.length) {
              $formInner.remove();
            }
            $form.append(message);
          }
        },
        async: false,
      });
      return subscribed;
    }

    $('#preview-klaviyo').click(function (event) {
      event.preventDefault();
      const listID = $('#preview-klaviyo-form').data('listid');
      const email = $('#preview-klaviyo-email').val();
      const source = 'Pre-Launch Page';
      if (email != '') {
        KlaviyoSignup(listID, email, source);
      } else {
        console.log('requirements not met');
      }
    });
    /*****************************************************************
      END Klaviyo form integration
    *****************************************************************/
  });
})(jQuery);
